import { ElisaYrityspuheUusiOfferCode, SubscriptionCardType } from '../../../common/enums';
import { elisaKukaSoittaaMsg, mBpsMsg, selectMsg, t } from '../../../common/i18n';
import { SUBSCRIPTION_CHANGE_SERVICE_FEE } from './LaitenettiSubscriptionCardContent';
import {
  getKukaSoittaaService,
  getMobiiliturvaService,
  getMobiilivarmenneService,
  getReissunetti1Service,
  getReissunetti2Service,
} from './ServiceContentCreator';
import type { SubscriptionCardProps } from '../../SubscriptionCard/SubscriptionCard';

const voiceSubscriptionCards = (inPublicStore?: boolean): Omit<SubscriptionCardProps, 'name'>[] => [
  {
    description: t.CVSQ('Efficient remote work, sending and receiving large files, streaming.'),
    cardName: 'puhepremium',
    mainHeader: 'Yrityspuhe Premium',
    monthlyPrice: 5999,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePremium,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePremium,
        icon: 'speed-meter-XL',
        text: t.IJNS(mBpsMsg, '1000'),
      },
    ],
    services: [getMobiiliturvaService(true, inPublicStore), getKukaSoittaaService(true), getReissunetti2Service(true)],
  },
  {
    description: t.CVSQ('Efficient remote work, sending and receiving large files, streaming.'),
    cardName: 'puhepro',
    mainHeader: 'Yrityspuhe Pro',
    monthlyPrice: 4499,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePro600M,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePro600M,
        text: t.ZKZZ(elisaKukaSoittaaMsg),
      },
      {
        icon: 'speed-upgrade',
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePro1000M,
        text: t.UWU7('Speed Upgrade {} Mbps', '1000'),
      },
    ],
    services: [
      getMobiiliturvaService(true, inPublicStore),
      getMobiilivarmenneService(true),
      getReissunetti2Service(true),
      getKukaSoittaaService(true, ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePro600M),
    ],
  },
  {
    description: t.CVSQ('Efficient remote work, sending and receiving large files, streaming.'),
    cardName: 'puheplus',
    mainHeader: 'Yrityspuhe Plus',
    monthlyPrice: 2999,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePlus100M,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePlus100M,
        text: t.ZKZZ(elisaKukaSoittaaMsg),
      },
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePlus300M,
        text: t.UWU7('Speed Upgrade {} Mbps', '300'),
      },
    ],
    services: [
      getMobiilivarmenneService(true),
      getReissunetti1Service(true),
      getKukaSoittaaService(true, ElisaYrityspuheUusiOfferCode.VoiceYrityspuhePlus100M),
    ],
  },
  {
    description: t.CVSQ('Efficient remote work, sending and receiving large files, streaming.'),
    cardName: 'puhebasic',
    mainHeader: 'Yrityspuhe Basic',
    monthlyPrice: 1499,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheBasic,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheBasic,
      },
    ],
    services: [getMobiilivarmenneService(true)],
  },
  {
    description: t.N1Y3('For light everyday use, web browsing and messaging.'),
    cardName: 'puhelite50m',
    mainHeader: 'Yrityspuhe Lite 50M',
    monthlyPrice: 1499,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite50M,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite50M,
      },
    ],
  },
  {
    description: t.N2A7('For smooth everyday use, web browsing, and email.'),
    cardName: 'puhelite100m',
    mainHeader: 'Yrityspuhe Lite 100M',
    monthlyPrice: 2499,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite100M,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite100M,
      },
    ],
  },
  {
    description: t.N1Z1('For worry-free everyday use, web browsing, and video calls.'),
    cardName: 'puhelite300m',
    mainHeader: 'Yrityspuhe Lite 300M',
    monthlyPrice: 3499,
    oneTimePrice: 899,
    recommended: false,
    selectedOffer: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite300M,
    offers: [
      {
        guid: ElisaYrityspuheUusiOfferCode.VoiceYrityspuheLite300M,
      },
    ],
    services: [getReissunetti1Service(true)],
  },
];

export const getVoiceSubscriptionCardContents = (
  inPublicStore?: boolean,
  isChangeOffer?: boolean
): SubscriptionCardProps[] => {
  return voiceSubscriptionCards(inPublicStore).map(cardContent => ({
    ...cardContent,
    serviceFee: isChangeOffer ? SUBSCRIPTION_CHANGE_SERVICE_FEE : undefined,
    buttonText: t.QRYV(selectMsg),
    cardType: SubscriptionCardType.VOICE,
  }));
};
